/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Subscribedtopics1Inputs */

const id_notifications_subscribedtopics1 = /** @type {(inputs: Notifications_Subscribedtopics1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Topik yang Dilanggani:`)
};

const ms_notifications_subscribedtopics1 = /** @type {(inputs: Notifications_Subscribedtopics1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Topik Dilanggan:`)
};

const da_notifications_subscribedtopics1 = /** @type {(inputs: Notifications_Subscribedtopics1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonnerede Emner:`)
};

const de_notifications_subscribedtopics1 = /** @type {(inputs: Notifications_Subscribedtopics1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonnierte Themen:`)
};

const en_us2_notifications_subscribedtopics1 = /** @type {(inputs: Notifications_Subscribedtopics1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subscribed Topics:`)
};

const es_es2_notifications_subscribedtopics1 = /** @type {(inputs: Notifications_Subscribedtopics1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Temas suscritos:`)
};

const es_mx2_notifications_subscribedtopics1 = /** @type {(inputs: Notifications_Subscribedtopics1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Temas suscritos:`)
};

const fil_notifications_subscribedtopics1 = /** @type {(inputs: Notifications_Subscribedtopics1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga Naka-subscribe na Paksa:`)
};

const fr_notifications_subscribedtopics1 = /** @type {(inputs: Notifications_Subscribedtopics1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sujets abonnés :`)
};

const it_notifications_subscribedtopics1 = /** @type {(inputs: Notifications_Subscribedtopics1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Argomenti sottoscritti:`)
};

const hu_notifications_subscribedtopics1 = /** @type {(inputs: Notifications_Subscribedtopics1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feliratkozott témák:`)
};

const nl_notifications_subscribedtopics1 = /** @type {(inputs: Notifications_Subscribedtopics1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geabonneerde onderwerpen:`)
};

const no_notifications_subscribedtopics1 = /** @type {(inputs: Notifications_Subscribedtopics1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonnerte emner:`)
};

const pl_notifications_subscribedtopics1 = /** @type {(inputs: Notifications_Subscribedtopics1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subskrybowane tematy:`)
};

const pt_br2_notifications_subscribedtopics1 = /** @type {(inputs: Notifications_Subscribedtopics1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tópicos inscritos:`)
};

const pt_notifications_subscribedtopics1 = /** @type {(inputs: Notifications_Subscribedtopics1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tópicos subscritos:`)
};

const ro_notifications_subscribedtopics1 = /** @type {(inputs: Notifications_Subscribedtopics1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subiecte abonate:`)
};

const fi_notifications_subscribedtopics1 = /** @type {(inputs: Notifications_Subscribedtopics1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tilatut aiheet:`)
};

const sv_notifications_subscribedtopics1 = /** @type {(inputs: Notifications_Subscribedtopics1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prenumererade ämnen:`)
};

const vi_notifications_subscribedtopics1 = /** @type {(inputs: Notifications_Subscribedtopics1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chủ đề đã đăng ký:`)
};

const tr_notifications_subscribedtopics1 = /** @type {(inputs: Notifications_Subscribedtopics1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abone Olunan Konular:`)
};

const cs_notifications_subscribedtopics1 = /** @type {(inputs: Notifications_Subscribedtopics1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odebíraná témata:`)
};

const bg_notifications_subscribedtopics1 = /** @type {(inputs: Notifications_Subscribedtopics1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Абонирани теми:`)
};

const ru_notifications_subscribedtopics1 = /** @type {(inputs: Notifications_Subscribedtopics1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подписанные темы:`)
};

const uk_notifications_subscribedtopics1 = /** @type {(inputs: Notifications_Subscribedtopics1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Підписані теми:`)
};

const ar_notifications_subscribedtopics1 = /** @type {(inputs: Notifications_Subscribedtopics1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الموضوعات المشترك فيها:`)
};

const hi_notifications_subscribedtopics1 = /** @type {(inputs: Notifications_Subscribedtopics1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सब्सक्राइब किए गए विषय:`)
};

const th_notifications_subscribedtopics1 = /** @type {(inputs: Notifications_Subscribedtopics1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`หัวข้อที่สมัครรับ:`)
};

const ja_notifications_subscribedtopics1 = /** @type {(inputs: Notifications_Subscribedtopics1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`購読中のトピック：`)
};

const zh_cn2_notifications_subscribedtopics1 = /** @type {(inputs: Notifications_Subscribedtopics1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已订阅主题：`)
};

const zh_hant1_notifications_subscribedtopics1 = /** @type {(inputs: Notifications_Subscribedtopics1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已訂閱主題：`)
};

const ko_notifications_subscribedtopics1 = /** @type {(inputs: Notifications_Subscribedtopics1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`구독한 주제:`)
};

/**
* | output |
* | --- |
* | "Subscribed Topics:" |
*
* @param {Notifications_Subscribedtopics1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const notifications_subscribedtopics1 = /** @type {((inputs?: Notifications_Subscribedtopics1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Subscribedtopics1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_notifications_subscribedtopics1(inputs)
	if (locale === "ms") return ms_notifications_subscribedtopics1(inputs)
	if (locale === "da") return da_notifications_subscribedtopics1(inputs)
	if (locale === "de") return de_notifications_subscribedtopics1(inputs)
	if (locale === "en-US") return en_us2_notifications_subscribedtopics1(inputs)
	if (locale === "es-ES") return es_es2_notifications_subscribedtopics1(inputs)
	if (locale === "es-MX") return es_mx2_notifications_subscribedtopics1(inputs)
	if (locale === "fil") return fil_notifications_subscribedtopics1(inputs)
	if (locale === "fr") return fr_notifications_subscribedtopics1(inputs)
	if (locale === "it") return it_notifications_subscribedtopics1(inputs)
	if (locale === "hu") return hu_notifications_subscribedtopics1(inputs)
	if (locale === "nl") return nl_notifications_subscribedtopics1(inputs)
	if (locale === "no") return no_notifications_subscribedtopics1(inputs)
	if (locale === "pl") return pl_notifications_subscribedtopics1(inputs)
	if (locale === "pt-BR") return pt_br2_notifications_subscribedtopics1(inputs)
	if (locale === "pt") return pt_notifications_subscribedtopics1(inputs)
	if (locale === "ro") return ro_notifications_subscribedtopics1(inputs)
	if (locale === "fi") return fi_notifications_subscribedtopics1(inputs)
	if (locale === "sv") return sv_notifications_subscribedtopics1(inputs)
	if (locale === "vi") return vi_notifications_subscribedtopics1(inputs)
	if (locale === "tr") return tr_notifications_subscribedtopics1(inputs)
	if (locale === "cs") return cs_notifications_subscribedtopics1(inputs)
	if (locale === "bg") return bg_notifications_subscribedtopics1(inputs)
	if (locale === "ru") return ru_notifications_subscribedtopics1(inputs)
	if (locale === "uk") return uk_notifications_subscribedtopics1(inputs)
	if (locale === "ar") return ar_notifications_subscribedtopics1(inputs)
	if (locale === "hi") return hi_notifications_subscribedtopics1(inputs)
	if (locale === "th") return th_notifications_subscribedtopics1(inputs)
	if (locale === "ja") return ja_notifications_subscribedtopics1(inputs)
	if (locale === "zh-CN") return zh_cn2_notifications_subscribedtopics1(inputs)
	if (locale === "zh-Hant") return zh_hant1_notifications_subscribedtopics1(inputs)
	return ko_notifications_subscribedtopics1(inputs)
});
export { notifications_subscribedtopics1 as "notifications.subscribedTopics" }